<template>
  <div>
    <Container :mobile-fluid="true">
      <ul class="list-group has-top-border">
        <li
          class="list-group-item"
          v-for="(event, index) in events"
          :key="index"
        >
          <EventRow :event="event" />
        </li>
      </ul>
    </Container>
    <Container>
      <div class="text-right space-t-3">
        <router-link :to="$wcRouter.path({ name: 'meeting.index' })">
          予定一覧を見る
        </router-link>
      </div>
    </Container>
  </div>
</template>

<script>
import EventRow from '@/components/EventRow'

export default {
  props: {
    events: {
      type: Array,
      required: true,
    },
  },

  components: {
    EventRow,
  },
}
</script>
